"use client";
const i = /(?:youtu\.be|youtube|youtube\.com|youtube-nocookie\.com)(?:\/shorts)?\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=|)((?:\w|-){11})/, u = /* @__PURE__ */ new Map(), s = /* @__PURE__ */ new Map();
function h(e) {
  return e.match(i)?.[1];
}
async function b(e, n) {
  if (u.has(e)) return u.get(e);
  if (s.has(e)) return s.get(e);
  const t = new Promise(async (c) => {
    const r = ["maxresdefault", "sddefault", "hqdefault"];
    for (const a of r)
      for (const f of [!0, !1]) {
        const o = p(e, a, f);
        if ((await fetch(o, {
          mode: "no-cors",
          signal: n.signal
        })).status < 400) {
          u.set(e, o), c(o);
          return;
        }
      }
  }).catch(() => "").finally(() => s.delete(e));
  return s.set(e, t), t;
}
function p(e, n, t) {
  return `https://i.ytimg.com/${t ? "vi_webp" : "vi"}/${e}/${n}.${t ? "webp" : "jpg"}`;
}
export {
  b as findYouTubePoster,
  h as resolveYouTubeVideoId
};
